interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/10 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/f4a5fda4-6702-4a1a-81df-74c6f18528d3.png" 
              alt="ロゴ" 
              className="h-10 w-auto"
            />
          </div>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('service')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              サービス概要
            </button>
            <button
              onClick={() => scrollToSection('plans')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              料金プラン
            </button>
            <button
              onClick={() => scrollToSection('cases')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              利用シーン
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-[#14B8A6] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#0F9B8E] transition-colors whitespace-nowrap cursor-pointer"
            >
              無料相談・お問い合わせ
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
